const INSTANCES = [
  {
    id: 12,
    tenantId: 'valitype',
    instanceId: 'dash',
    brandOrigin: 'valitype.com',
    audience: 'dashboard',
    status: 'active',
    defaultLocale: 'de-DE',
    themeVersion: 7,
    themePublishedAt: '2026-06-20T11:04:00Z',
    enabledPlugins: ['core-auth', 'customer-dashboard', 'tickets'],
    domains: [
      { hostname: 'dash.valitype.com', isCanonical: true, sslStatus: 'active' },
    ],
  },
  {
    id: 13,
    tenantId: 'valitype',
    instanceId: 'public',
    brandOrigin: 'valitype.com',
    audience: 'marketing',
    status: 'active',
    defaultLocale: 'de-DE',
    themeVersion: 3,
    themePublishedAt: '2026-06-19T08:30:00Z',
    enabledPlugins: ['marketing-pages', 'wordpress-source'],
    domains: [
      { hostname: 'valitype.com', isCanonical: true, sslStatus: 'active' },
      { hostname: 'www.valitype.com', isCanonical: false, sslStatus: 'active' },
    ],
  },
];

const DEFAULT_TOKENS = {
  'color.brand': '#175cff',
  'color.accent': '#00a676',
  'color.surface': '#ffffff',
  'color.ink': '#0b1120',
  'color.muted': '#5b6577',
  'font.body': 'Inter',
  'font.heading': 'Inter',
  'radius.card': '12px',
  'layout.contentMax': '1180px',
};

export function mtffInstancesFixture() {
  return { instances: INSTANCES };
}

export function mtffInstanceFixture(id) {
  const inst = INSTANCES.find((i) => String(i.id) === String(id)) ?? INSTANCES[0];
  return inst;
}

export function mtffThemesFixture(id) {
  const inst = INSTANCES.find((i) => String(i.id) === String(id)) ?? INSTANCES[0];
  return {
    themes: [
      { version: inst.themeVersion, isPublished: true, createdAt: inst.themePublishedAt },
      { version: inst.themeVersion - 1, isPublished: false, createdAt: '2026-06-19T08:00:00Z' },
      { version: inst.themeVersion - 2, isPublished: false, createdAt: '2026-06-18T07:00:00Z' },
    ].filter((t) => t.version > 0),
  };
}

export function mtffThemeVersionFixture(_id, _version) {
  return {
    version: _version,
    isPublished: true,
    tokens: { ...DEFAULT_TOKENS, 'color.brand': '#ff6600', 'color.accent': '#ffcc00' },
  };
}

export function mtffPreviewTokenFixture({ instanceId, actor, ttlSec, themeVersion }) {
  const token = `fixture.${btoa(JSON.stringify({ actor, themeVersion })).replace(/=/g, '')}.sig`;
  return {
    token,
    expiresIn: ttlSec,
    enterUrl: `/api/preview-theme/enter?token=${encodeURIComponent(token)}&to=/`,
    auditId: Math.floor(Math.random() * 1e6),
    instanceId,
  };
}
